


class BusinessCell extends MUITableViewCell 
{    
    private nameLabel:MUILabel = null;        

    awakeFromHTML() {
        this.nameLabel = MUIOutlet(this, 'name-lbl', 'MUILabel');
    }
    
    set item(b) {                
        this.nameLabel.text = b["name"];
        // Served by another cluster: visible, not selectable from this manager.
        if (b["remote"] == true) MUICoreLayerAddStyle(this.layer, "remote");
        else MUICoreLayerRemoveStyle(this.layer, "remote");
    }
}
